import React from 'react';
import type { ChartIndicatorsProps } from '@atlassian/jira-software-deployments-common-table/src/components/table';
import { useIssueDeployments } from '../../../services/core-data';
import NavigateIndicators from './navigate-indicators';

export type Props = ChartIndicatorsProps;

const ChartIndicators = ({ id: issueId, getPositionFromDate }: Props) => {
	const deploymentsResult = useIssueDeployments(issueId);

	return (
		<NavigateIndicators
			deployments={deploymentsResult.data || []}
			getPositionFromDate={getPositionFromDate}
		/>
	);
};

export default ChartIndicators;
